import { View, Text } from 'react-native'
import React, { useMemo } from 'react'
import { Theme, ThemedText } from '@app/theme'
import { ThemedView } from '@app/theme'
import SystemWarning from '@app/assets/svg/SystemWarning'
import Button from '@app/sharedComponents/Button/Button'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import { useTheme } from '@shopify/restyle'
import { trackEvent } from '@app/utils/amplitude'





const ErrorMandateModal = ({ error, onContactUs, onRetry, onChange ,isProcessing }: { error: any, onContactUs: () => void, onRetry: () => void, onChange: () => void , isProcessing : boolean }) => {


    const actionMap = useMemo(() => {
        return {
            'CHANGE': onChange,
            'RETRY': onRetry,
            'CONTACT_US': onContactUs,
        }
    }, [onChange, onRetry, onContactUs])

    const { colors } = useTheme<Theme>();
    trackEvent('MANDATE_FAIL_PAGE_VIEWED',{error: error?.message})


    return (
        <ThemedView alignItems='center' padding='lg'>
            <SystemWarning color={colors['icon-error']} size={48} />
            <ThemedText mt='xl' mb='lg' variant='h5s' color='text-primary'>
                {error?.header}
            </ThemedText>
            <ThemedText mb='xl' textAlign='center' variant='b3r' color='text-secondary'>
                {error?.message}
            </ThemedText>
            {error?.primaryCtaText &&
                <ThemedView alignSelf='stretch' mb='md'>
                    <Button size='MD' label={error?.primaryCtaText} handlePress={actionMap[error?.primaryCtaAction as keyof typeof actionMap]} bg='bg-primary' textColor='text-white' />
                </ThemedView>
            }
            {error?.secondaryCtaText &&
                <ThemedView alignSelf='stretch' mb='md'>
                    <Button size='MD' buttonLoader={isProcessing} label={error?.secondaryCtaText} handlePress={actionMap[error?.secondaryCtaAction as keyof typeof actionMap]} bg='bg-primary' textColor='text-white' type='OUTLINED' />
                </ThemedView>
            }
            {error?.tertiaryCtaText &&
                <ThemedView flexDirection='row' justifyContent='center' alignItems='center' alignSelf='stretch' mb='md'>
                    <ThemedText mr='sm' variant='b3r' color='text-secondary'>Need Help?</ThemedText>
                    <ThemedTouchableOpacity onPress={actionMap[error?.tertiaryCtaAction as keyof typeof actionMap]}>
                        <ThemedText variant='b3b' color='text-action-primary'>{error?.tertiaryCtaText}</ThemedText>
                    </ThemedTouchableOpacity>
                </ThemedView>
            }
        </ThemedView>
    )
}

export default ErrorMandateModal